export enum SecurityTemplates {
  CHOICE_VALUES_ADMIN_ACCESS = 'choiceValuesAdminAccess',
  S3BROWSER_ACCESS = 's3BrowserAccess',
  OBJECT_SEARCH_ACCESS = 'objectSearchAccess',
  OBJECT_CHECKIN_ACCESS = 'objectCheckinAccess',
  OBJECT_DETAILS_ADMIN_ACCESS = 'objectDetailsAdminAccess'
}
